import { v2, type Document } from '@/api/v2Client';

/** The documents endpoint defaults to 50 rows and caps pages at 200. */
export async function listAllSubmissionDocuments(submissionId: string): Promise<Document[]> {
  const documents: Document[] = [];
  const limit = 200;
  for (let offset = 0; ; offset += limit) {
    const page = await v2.documents.listBySubmission(submissionId, { limit, offset });
    documents.push(...page);
    if (page.length < limit) return documents;
  }
}
